import React, { useState } from "react";
import { Form, Input, Select } from "antd";
import FormPage from "../../../../../components/pages/FormPage";
import { useSelector } from "react-redux";

const DefModel = {
    name: "",
    username: "",
    password: "",
    pjt_id: null,
    isCreate: true
};

export default () => {
    const { pjtCache } = useSelector(state => state.apps);
    const [model, setModel] = useState(DefModel);

    const resultModel = { ...model, pjt_id: model?.pjt_id?._id || model?.pjt_id }

    return (
        <FormPage
            url={"api/v1/user_pjt"}
            callbackPath={"/master/user_pjt"}
            formValid={false}
            model={resultModel}
            setModel={setModel}
            title={"Users PJT"}
            wrapperCol={{ span: 8 }}
            labelCol={{ span: 3 }}
        >
            <Form.Item name={"pjt_id"} label="PJT" rules={[{ required: true, message: "Pilih PJT!" }]}>
                <Select
                    className="input-custom-md"
                    size="default"
                    onChange={(value) => setModel({ ...model, pjt_id: value })}
                    value={model.pjt_id}
                    rules={[{ required: true }]}
                >
                    {pjtCache.map((pjt) => (
                        <Select.Option key={pjt._id} value={pjt._id}>
                            {pjt.name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item name={"name"} label="name">
                <Input className="input-custom-md" size="default" rules={[{ required: true }]} />
            </Form.Item>
            <Form.Item name={"username"} label="username" rules={[{ required: true }]}>
                <Input className="input-custom-md" size="default" />
            </Form.Item>
            <Form.Item name={"password"} label="password">
                <Input className="input-custom-md" size="default" rules={[{ required: true }]} />
            </Form.Item>
        </FormPage>
    );
}